import styled from "@emotion/styled";
import React from "react";

const ButtonCustom = (props: any) => {
  const children = props.children;
  return <button {...props}>{children ? children : "Button"}</button>;
};

export const Button = styled(ButtonCustom)`
  color: ${(props) => (props.color ? props.color : "var(--white-color)")};
  outline: none;
  cursor: pointer;
  border: 1px solid ${(props) => (props.border ? props.border : "#11643C")};
  background-color: ${(props) => (props.bg ? props.bg : "#11643C")};
  padding: 10px 35px;
  border-radius: 5px;
`;
